export default "bbc94bca56ee90ee.svg"